export default __webpack_public_path__ + "static/media/no-active-contracts.58d9e5e9.svg";